import type { ComponentProps } from "react";
import { memo } from "react";
import * as Styled from "./style";

type PlayButtonProps = Omit<ComponentProps<typeof Styled.Button>, "name">;

/**
 * 映像再生のアイコンボタン
 * @param props {@link PlayButtonProps}
 */
export const PlayButton = memo((props: PlayButtonProps) => {
  return (
    <Styled.Button type="button" name="再生ボタン" iconName="play" bgColor="YELLOW900" iconColor="GRAY50" {...props} />
  );
});

PlayButton.displayName = "PlayButton";
